/* eslint-disable indent */
/* global initCookieConsent */

import { Dropdown } from 'bootstrap'
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import Mmenu from 'mmenu-js'

import { setupAjaxUtils, useAjaxAutoBrowserHistoryUpdate } from './ajax-utils'
import './clipboard.init.js'
import 'sharer.js/sharer.js'
import 'vanilla-cookieconsent';
import "vanilla-cookieconsent/dist/cookieconsent.css"
import '../scss/application.scss'

$(function () {
	// initialize ajax-utils
	setupAjaxUtils();
});

$(document).ready(function () {
	new Mmenu("#menu", {
		"offCanvas": {
			"position": "right"
		},
		"theme": "light",
	});
})

/*
 *  Share article
 */

$(function () {
	$(".btn-social-trigger").on("click", function (ev) {
		ev.preventDefault();
		setTimeout(function () {
			$('.sharebuttons').toggleClass('active');
		}, 200);
	})
})

/*
 *  Parallax Effect
 */

$(function () {
	var boxes = $('.parallax-container'),
		$window = $(window);
	$window.scroll(function () {
		var scrollTop = $window.scrollTop();
		boxes.each(function () {
			var $this = $(this),
				scrollspeed = parseInt($this.data('scroll-speed')),
				val = - scrollTop / scrollspeed;
			$this.css('transform', 'translateY(' + val + 'px)');
		});
	});
})


/*
 *  Main Carsouel
 */

$(function () {
	const swiper = new Swiper('#main-carousel', {
		modules: [Navigation, Pagination, Autoplay],
		autoHeight: false,
		loop: true,
		pagination: {
			el: $('#main-carousel').find('.swiper-pagination')[0],
			clickable: true,
		},
		autoplay: {
			delay: (location.hostname == "localhost" ? 5000000 : 5000),
		},
		speed: 400,
		on: {
			init: function () {
				$('#main-carousel').find('.swiper-slide[data-swiper-slide-index=0] .swiper-slide-info *').css({ display: "block" });
				$("#main-carousel").find('.swiper-slide[data-swiper-slide-index=0] .swiper-slide-bg .video').trigger('play');
			},
			slideChange: function () {
				$('#main-carousel').find('.swiper-slide .swiper-slide-info *').hide();
				$('#main-carousel').find('.swiper-slide[data-swiper-slide-index=' + this.realIndex + '] .swiper-slide-info *').css({ display: "block" });

				if ($('#main-carousel').find('.swiper-slide[data-swiper-slide-index=' + this.realIndex + '] .swiper-slide-bg .video').length > 0) {
					$('#main-carousel').find('.swiper-slide[data-swiper-slide-index=' + this.realIndex + '] .swiper-slide-bg .video').trigger('play');
				} else {
					$('#main-carousel').find('.video').trigger('pause');
				}
			}
		},
		breakpoints: {

		}
	});
})

/*
 *  Init Carsouels
 */
$(document).ready(function () {
	$('.swiper-element').each(function () {
		var $this = $(this);
		var config = $this.data('swiper');
		config.modules = [Navigation, Pagination, Autoplay];
		if ($this.find('.swiper-button').length) {
			config.navigation = {
				nextEl: $this.find('.swiper-button-next')[0],
				prevEl: $this.find('.swiper-button-prev')[0],
			}
		} else if ($this.hasClass("swiper-element-card")) {
			config.navigation = {
				nextEl: $('.academy').find('.swiper-button-next')[0],
				prevEl: $('.academy').find('.swiper-button-prev')[0],
			}
		} else if ($this.hasClass("swiper-element-media-card")) {
			config.navigation = {
				nextEl: $('.media-card').find('.swiper-button-next')[0],
				prevEl: $('.media-card').find('.swiper-button-prev')[0],
			}
		} else if ($this.hasClass("swiper-element-gallery")) {
			config.navigation = {
				nextEl: $('.gallery').find('.swiper-button-next')[0],
				prevEl: $('.gallery').find('.swiper-button-prev')[0],
			}
		} else if ($this.hasClass("swiper-element-img")) {
			config.navigation = {
				nextEl: $('.news').find('.swiper-button-next')[0],
				prevEl: $('.news').find('.swiper-button-prev')[0],
			}
		}
		var swiper = new Swiper($this.find('.swiper')[0], config);
	})

})


$(function () {

	// IN SOSPESO FINO A NUOVE ISTRUZIONI DAL CLIENTE
	// return;

	const cookiePolicyUrl = $('body').data("cookie-policy-url");

	// obtain plugin
	var cc = initCookieConsent();

	// run plugin with your configuration
	cc.run({
		current_lang: 'it',
		page_scripts: true,                        // default: false
		delay: 1500,                               // default: 0
		cookie_name: 'cookie_consent',             // default: 'cc_cookie'

		//autoclear_cookies: true,                 // default: false
		// mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
		// auto_language: '',                      // default: null; could also be 'browser' or 'document'
		// autorun: true,                          // default: true
		// force_consent: false,                   // default: false
		// hide_from_bots: false,                  // default: false
		// remove_cookie_tables: false             // default: false

		// cookie_expiration: 182,                 // default: 182 (days)
		// cookie_necessary_only_expiration: 182   // default: disabled
		// cookie_domain: location.hostname,       // default: current domain
		// cookie_path: '/',                       // default: root
		// cookie_same_site: 'Lax',                // default: 'Lax'
		// use_rfc_cookie: false,                  // default: false
		// revision: 0,                            // default: 0

		onFirstAction: function (user_preferences, cookie) {
			if (user_preferences.accepted_categories.indexOf("third_part") != -1) {
				location.reload();
			}
			//console.log('User accept type:', user_preferences.accept_type);
			//console.log('User accepted these categories', user_preferences.accepted_categories)
			//console.log('User reject these categories:', user_preferences.rejected_categories);
		},

		onAccept: function (cookie) {
			//console.log(cookie);
			// callback triggered on the first accept/reject action, and after each page load
		},

		onChange: function (cookie, changed_categories) {
			if (changed_categories.indexOf("third_part") != -1) {
				location.reload();
			}
		},

		languages: {
			'it': {
				consent_modal: {
					title: 'Cookie policy',
					description: 'Questo sito utilizza i cookie per garantire il suo corretto funzionamento e una migliore esperienza di navigazione. Tutti i cookie, tranne quelli strettamente necessari al funzionamento del sito, richiedono un consenso esplicito da parte tua. <button type="button" data-cc="c-settings" class="cc-link">Visualizza le preferenze</button>',
					primary_btn: {
						text: 'Accetta tutti',
						role: 'accept_all'              // 'accept_selected' or 'accept_all'
					},
					secondary_btn: {
						text: 'Rifiuta tutti',
						role: 'accept_necessary'        // 'settings' or 'accept_necessary'
					}
				},
				settings_modal: {
					title: 'Preferenze sui cookie',
					save_settings_btn: 'Salva',
					accept_all_btn: 'Accetta tutti',
					reject_all_btn: 'Rifiuta tutti',
					close_btn_label: 'Chiudi',
					cookie_table_headers: [
						{ col1: 'Nome' },
						{ col2: 'Dominio' },
						{ col3: 'Durata' },
						{ col4: 'Descrizione' }
					],
					blocks: [
						{
							title: 'Uso dei cookie',
							description: 'Questo sito utilizza cookie essenziali per garantire il suo corretto funzionamento, cookie di terze parti per fornirti una migliore esperienza di navigazione e cookie di tracciamento per capire come interagisci con esso. I cookie di tracciamento e di terze parti verranno impostati solo dopo il tuo consenso.'
						}, {
							title: 'Cookie tecnici strettamente necessari per la navigazione',
							description: 'Questi cookie sono essenziali per il corretto funzionamento del sito web. Senza questi cookie la navigazione sarebbe impossibile.',
							toggle: {
								value: 'necessary',
								enabled: true,
								readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: 'ASP.NET_SessionId',
									col2: location.host,
									col3: 'Scade con la sessione di navigazione',
									col4: 'Memorizza la sessione di navigazione corrente'
								},
								{
									col1: 'cookie_consent',
									col2: location.host,
									col3: '6 mesi',
									col4: 'Memorizza le preferenze sui cookie da te impostate'
								}
							]
						},
						//{
						//    title: 'Cookie di tracciamento',
						//    description: 'Questi cookie ci permettono di ricevere informazioni utili a migliorare i nostri contenuti in base alle abitudini di navigazione degli utenti.',
						//    toggle: {
						//        value: 'unnecessary',     // your cookie category
						//        enabled: false,
						//        readonly: false
						//    },
						//    cookie_table: [             // list of all expected cookies
						//        {
						//            col1: '_pk_ses',
						//            col2: location.host,
						//            col3: '30 minuti',
						//            col4: 'Cookie di breve durata per memorizzare temporaneamente i dati relativi alla visita'
						//        },
						//        {
						//            col1: '_pk_cvar',
						//            col2: location.host,
						//            col3: '30 minuti',
						//            col4: 'Cookie di breve durata per memorizzare temporaneamente i dati relativi alla visita'
						//        },
						//        {
						//            col1: '_pk_hsr ',
						//            col2: location.host,
						//            col3: '30 minuti',
						//            col4: 'Cookie di breve durata per memorizzare temporaneamente i dati relativi alla visita'
						//        },
						//        {
						//            col1: '_pk_id',
						//            col2: location.host,
						//            col3: '13 mesi',
						//            col4: 'Memorizza alcuni dettagli sull\'utente come l\'ID univoco'
						//        }
						//    ]
						//},
						{
							title: 'Cookie di terze parti ',
							description: 'Questi cookie ci permettono di arricchire l\'esperienza di navigazione con contenuti multimediali provenienti da altre piattaforme.',
							toggle: {
								value: 'third_part',     // your cookie category
								enabled: false,
								readonly: false
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: 'CONSENT',
									col2: '.youtube-nocookie.com',
									col3: 'Scade con la sessione di navigazione',
									col4: 'Dopo che l\'utente ha dato il proprio consenso, il cookie CONSENT salva l\'autorizzazione dell\'utente a inoltrare i dati a YouTube'
								}
							]
						},
						{
							title: 'Maggiori informazioni',
							description: `Per maggiori informazioni sulla nostra cookie policy <a class="cc-link" href="${cookiePolicyUrl}">visita la pagina ad essa dedicata</a>`
						}
					]
				}
			}
		}
	});
	var imgCss = 'img{max-width: 100%}';
	var bodyCss = 'body{display:flex;align-items:center}';
	var style = document.createElement("style");
	style.appendChild(document.createTextNode(imgCss));
	style.appendChild(document.createTextNode(bodyCss));
	$("iframe").each(function () {
		if (!this.contentDocument) return;
		this.contentDocument.head.append(style);
	})
})


/* Cookie buttons */
$(function () {
	$("#cookie-tab").fadeIn();
});
/* Cookie buttons */